export const backendTestEn = {
  pageTitle: 'Backend Connection Test',
  subtitle: 'Test the jsontransfer API endpoints. PUT creates a record, GET retrieves it, DELETE removes it.',

  put: {
    title: 'PUT — Create / Update',
    description: 'Send a test payload to create or update a record.',
    button: 'Send PUT',
    sending: 'Sending…',
  },
  get: {
    title: 'GET — Retrieve',
    description: 'Retrieve the record by ID. Run PUT first to have an ID to fetch.',
    button: 'Send GET',
    sending: 'Fetching…',
    noId: 'No ID available. Run a PUT request first.',
    idLabel: 'Query ID',
  },
  pullKeys: {
    title: 'GET — Pull Key Tests',
    description: 'Run GET using the same keys used by pullClientsFromBackend and pullListBuilderFromBackend.',
    clientsButton: 'Test Clients Pull Key',
    listBuilderButton: 'Test List Builder Pull Key',
    clientsIdLabel: 'Clients key',
    listBuilderIdLabel: 'List Builder key',
    running: 'Fetching…',
  },
  delete: {
    title: 'DELETE — Remove',
    description: 'Delete the record by ID. Run PUT first to have an ID to delete.',
    button: 'Send DELETE',
    sending: 'Deleting…',
    noId: 'No ID available. Run a PUT request first.',
    idLabel: 'Query ID',
  },

  requestSection: 'Request',
  responseSection: 'Response',
  method: 'Method',
  url: 'URL',
  payload: 'Payload',
  status: 'Status',
  statusCode: 'Status Code',
  responseBody: 'Response Body',
  responseTime: 'Response Time',
  noResponse: 'No response yet. Click the button to send a request.',
  success: 'Success',
  error: 'Error',
  networkError: 'Network Error',
  noContent: '(204 No Content)',
  ms: 'ms',
  lastId: 'Last PUT ID',
} as const;
